export const FEE_OTHER_LABEL_MESSAGE_IDS = Object.freeze({
  shipping: "order.adjustment.shipping-fee",
  service: "order.adjustment.service-fee",
  packing: "order.adjustment.packing-fee",
  other: "order.adjustment.other-fee",
});

export const normalizeFeeOtherLabel = (label) => {
  const normalized = String(label || "")
    .trim()
    .toLowerCase();

  return Object.prototype.hasOwnProperty.call(
    FEE_OTHER_LABEL_MESSAGE_IDS,
    normalized,
  )
    ? normalized
    : "other";
};

export const unwrapFeeOther = (feeOther) => {
  if (Array.isArray(feeOther)) return feeOther[0] || null;
  return feeOther || null;
};

export const findFeeOther = (source) => {
  if (!source) return null;
  if (Array.isArray(source)) return unwrapFeeOther(source);

  const direct = unwrapFeeOther(source.fee_other);
  if (direct) return direct;

  if (source.label !== undefined || source.value !== undefined) return source;

  if (Array.isArray(source.orders)) {
    for (const order of source.orders) {
      const feeOther = order && unwrapFeeOther(order.fee_other);
      if (feeOther) return feeOther;
    }
  }

  return null;
};

export const getFeeOtherLabelMessageId = (source) => {
  const feeOther = typeof source === "string" ? { label: source } : findFeeOther(source);
  const label = normalizeFeeOtherLabel(feeOther && feeOther.label);
  return FEE_OTHER_LABEL_MESSAGE_IDS[label];
};

export const getFeeOtherLabel = (messages = {}, source) => {
  const messageId = getFeeOtherLabelMessageId(source);
  return (
    messages[messageId] ||
    messages[FEE_OTHER_LABEL_MESSAGE_IDS.other] ||
    "Phí khác"
  );
};
